exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cookie-popup {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  min-height: 40px;\n  background: #1594A6;\n  z-index: 9999;\n  color: white;\n  padding: 10px;\n  font-size: 16px; }\n\n.content-wrapper {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center; }\n\na {\n  font-weight: bold;\n  color: white; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /agir/src/app/components/cookie-popup/cookie-popup.component.scss
// module id = ../../../../../src/app/components/cookie-popup/cookie-popup.component.scss
// module chunks = main